import { loadAndMigrateState, Migrator } from '@ps20-frontend/migrations';
import { Produktlinienname } from '@ps20/bff-models';
import { IAppState } from '../appState';

export const stateMigrators: Migrator[] = [];

export const loadAndMigrateVwgState = (
  currentState: IAppState,
  loadedState: { version: number },
): IAppState => {
  const migratedState = loadAndMigrateState(currentState, loadedState, stateMigrators) as IAppState;
  if (migratedState.buildingFeatures && migratedState.buildingFeatures.aussenpoolInHts == null) {
    const aussenpoolInHts = resolveAussenpoolInHtsDefault(migratedState);
    migratedState.buildingFeatures = { ...migratedState.buildingFeatures, aussenpoolInHts };
  }
  return migratedState;
};

function resolveAussenpoolInHtsDefault(state: IAppState): boolean | null {
  if (!state.buildingFeatures?.pool || !state.buildingFeatures?.poolOutdoors) {
    return null;
  }
  const komfortLinie = state.produkt?.produktlinien?.find(
    pl => pl.produktName === Produktlinienname.KOMFORT,
  );
  const htsSelected = !komfortLinie?.leistungen?.find(l => l.id === 'hausTechnikSchutz')?.abgewaehlt;
  return htsSelected ? true : null;
}
